import store from './store'; // path to your Vuex store
import app from './app'

const socket = {
	url: "",
	io: null,
	connect(){
		return new Promise((resolve, reject) => {
		  	store.dispatch('config/getConfig').then((conf) => {
				this.url = conf.socketIOBroadcasterUrl;
			    this.io = io(this.url.replace("socket.io/", ""), {'transports': ['websocket', 'polling'], autoConnect: true });

				this.io.on('connect', () => {
					console.log("socket.io connected");
					this.io.emit('join', { room: "common" });
					this.io.emit('join', { room: "auctions" });

					if(store.state.trivia.quiz != null){
						this.io.emit('join', { room: "trivia-quiz:" + store.state.trivia.quiz.id });
					}
				});

				this.io.on('connect_error', (error) => {
					console.log("socket.io connect_error");
				});

				this.io.on('disconnect', () => {
				  console.log("socket.io disconnect");
				});

				resolve(this.io);
			});
		})
	}
}

export default socket